import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../js/IncludeManager'
import { SimilarSearch } from './SimilarSearch'  
export class SimilarConfirm extends Component {
    static displayName = SimilarConfirm.name;
    
    constructor(props) {
        super(props);
        this.state = {
        };
        this.refSimilarSearch = React.createRef();
        this.ImageUrl = "";
        this.Uid = "";
        this.Goods_No = "";
        this.ShopName = "";
        this.ProductName = "";
    }
    //초기화
     componentDidMount() {
        //상품정보 조회
         var hiddenInput = document.getElementById('Similarity_Uid');
         hiddenInput.addEventListener('click', async (e)=>{
            const array_uid = hiddenInput.value.split("_");
            if (array_uid.length > 0) {
                this.Uid = array_uid[0];
                this.Goods_No = array_uid[1];
                let Data = await Big3Common.Post("api/Search/GoodsDtl/GetSimilarProductInfo",
                {
                    uid: this.Uid,
                    goods_no: this.Goods_No
                });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    const dataTable = JSON.parse(Data.dataTable);
                    if (dataTable.length > 0) {
                        this.ShopName = dataTable[0].goods_nm;
                        this.ProductName = dataTable[0].org_nm;
                        const VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
                        this.ImageUrl = `${VirtualRoot}${dataTable[0].img_220}`;

                        document.getElementById("Similarity_GoodsImage").style.backgroundImage = `url('${this.ImageUrl}')`;
                        document.getElementById("Similarity_ShopName").innerText = this.ShopName;
                        document.getElementById("Similarity_ProductName").innerText = this.ProductName;
                        Big3Common.ModalAlert(bootstrap, 'Imgae_Similarity');
                        e.preventDefault();
                        
                    }
                }
            }
         });
    }
    handle_Search = () => {
        this.refSimilarSearch.current.Search_Goods(this.Uid, this.Goods_No, this.ShopName, this.ProductName, this.ImageUrl);
    }
    //
    Layout_GoodsDtl = (data) => {
        console.log("Layout_GoodsDtl Callback1");
        this.props.callBack(data);
    }
    render() {
        return (
            <>
                <div className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id="Imgae_Similarity" data-bs-keyboard="false" data-bs-backdrop="static">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body text-center pn">
                                <div className="img_thumnail_box">
                                    <div className="thumnail_img" id="Similarity_GoodsImage"></div>
                                    <div className="img_info">
                                        <div className="shop_name" id="Similarity_ShopName"></div>
                                        <div className="product_name" id="Similarity_ProductName"></div>
                                        <input type="hidden" id="Similarity_Uid" />
                                    </div>
                                </div>

                                <div className="desc">
                                    <div className="modal_title">유사한 상품을 찾으시겠습니까?</div>
                                </div>
                            </div>
                            <div className="modal-footer notice_modal_footer">
                                <button type="button" className="m_btn m_btn2 f_delete" data-bs-dismiss="modal">취소</button>
                                <button type="button" className="m_btn m_btn2" data-bs-dismiss="modal" onClick={() => { this.handle_Search() } }>찾기</button>
                            </div>
                        </div>
                    </div>
                </div>
                <SimilarSearch
                    id="SimilarSearch"
                    ref={this.refSimilarSearch}
                    callBack={this.Layout_GoodsDtl}
                />
            </>
        );
    }
}
